import ButtonStyleItem from 'components/ButtonStyleItem'
import { nanoid } from 'nanoid'
import { ButtonStyle } from 'ts/types'

interface TableProps {
  data: ButtonStyle[]
  isLoading: boolean
  onItemClick: (data: object) => void
}

function Table({ isLoading, data, onItemClick }: TableProps) {
  return (
    <div className="flex flex-wrap pl-2">
      {data.length === 0 ? (
        <>{isLoading ? <>Loading</> : <>No data found</>}</>
      ) : (
        data.map((item) => (
          <ButtonStyleItem
            key={nanoid()}
            data={item}
            className={`my-2 mr-2`}
            onClick={() => onItemClick(item)}
          />
        ))
      )}
    </div>
  )
}

export default Table
